import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import Navbar from "@/components/Navbar";
import ProtectedRoute from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import TutorsBrowse from "@/pages/TutorsBrowse";
import TutorDetail from "@/pages/TutorDetail";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import BecomeTutor from "@/pages/BecomeTutor";
import HowItWorks from "@/pages/HowItWorks";
import AiPractice from "@/pages/AiPractice";
import Certificates from "@/pages/Certificates";
import CertificateView from "@/pages/CertificateView";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";

function Footer() {
  return (
    <footer className="border-t border-border/70 mt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 text-sm text-muted-foreground flex flex-wrap items-center justify-between gap-4">
        <span>© {new Date().getFullYear()} Tutors Paradise · Tutor marketplace</span>
        <span className="text-xs uppercase tracking-wider">French · English · Spanish · Math</span>
      </div>
    </footer>
  );
}

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <div className="App bg-grain min-h-screen flex flex-col">
            <Navbar />
            <main className="flex-1">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/tutors" element={<TutorsBrowse />} />
                <Route path="/tutors/:id" element={<TutorDetail />} />
                <Route path="/how-it-works" element={<HowItWorks />} />
                <Route path="/become-tutor" element={<BecomeTutor />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route
                  path="/dashboard"
                  element={
                    <ProtectedRoute>
                      <Dashboard />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/ai-practice"
                  element={
                    <ProtectedRoute>
                      <AiPractice />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/certificates"
                  element={
                    <ProtectedRoute>
                      <Certificates />
                    </ProtectedRoute>
                  }
                />
                <Route path="/certificates/:id" element={<CertificateView />} />
                <Route path="/payment/success" element={<PaymentSuccess />} />
                <Route path="/payment/cancel" element={<PaymentCancel />} />
              </Routes>
            </main>
            <Footer />
            <Toaster richColors position="top-right" />
          </div>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}
